var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.071,
    height: 58.315,
    viewBox: "0 0 62.071 58.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M.061,19c0-.649-.28-2.04.361-2.436.865-.534,1.207.5,1.431,1.156.441,1.3.236,3.461,1.038,4.517A43.263,43.263,0,0,1,26.239,2.71C36.205-.794,48.415-1.473,57.8,4.137c1.682,2.917-10.022-4.026-23.57-1.3a44.983,44.983,0,0,0-16.924,7.04,38.994,38.994,0,0,0-7.2,6.208c-1.77,1.994-4.758,5.2-5.3,7.9,2.378-.356,4.488-3.036,6.809-3.74,1.23-.373,2.638.226,1.784,1.612-.693,1.124-2.927,1.835-4.059,2.438-1.263.673-2.541,1.3-3.862,1.853-.969.405-2.877,1.676-3.908,1.264C-.243,26.68.115,20.662.061,19,.061,18.321.084,19.693.061,19Z",
    transform: "translate(62.071 21.058) rotate(140)",
    fill: "#3a404e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/arrow-black.3780486276f1f8b410b93aa4199c854c.svg";
export { ForwardRef as ReactComponent };